import { TimeService, useHasPermission } from "@dexteel/mesf-core";
import { logbookRoutesMESF } from "@/pages/logbook";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { workOrderRoutes } from "./routes/workOrderRoutes.routes";
import { taskListRoutes } from "./routes/taskListRoutes.routes";
import { mapRoutes } from "./routes/mapRoutes.routes";
import { templateRoutes } from "./routes/templateRoutes.routes";
import { formRoutes } from "./routes/formRoutes.routes";
import type { RouteConfig } from "./models/types";
import { documentRoutes } from "./routes/DrawingsBrowserPage.routes";
import UnauthorizedPage from "@/pages/errors/UnauthorizedPage";
import { WorkOrderModalsProvider } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { assetDetailsRoutes } from "./routes/assetDetailsRoutes.routes";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

interface RouteSection {
	routes: RouteConfig[];
}

const routeSections: RouteSection[] = [
	{ routes: mapRoutes },
	{ routes: workOrderRoutes },
	{ routes: taskListRoutes },
	{ routes: templateRoutes },
	{ routes: formRoutes },
	{ routes: logbookRoutesMESF },
	{ routes: documentRoutes },
	{ routes: assetDetailsRoutes },
];

const CustomRoutes = (): React.ReactElement => {
	const hasPermissionTo = useHasPermission();

	const canAccessRoute = (route: RouteConfig): boolean => {
		if (route.permission) {
			return hasPermissionTo(route.permission);
		}
		return true;
	};

	return (
		<LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
			<WorkOrderModalsProvider>
				<Routes>
					<Route path="/unauthorized" element={<UnauthorizedPage />} />

					{routeSections.map((section: RouteSection) => {
						return section.routes.map((route: RouteConfig) => {
							const canAccess: boolean = canAccessRoute(route);
							return (
								<Route
									key={`route-${route.path}`}
									path={route.path}
									element={
										canAccess ? (
											route.element
										) : (
											<Navigate to="/unauthorized" replace />
										)
									}
								/>
							);
						});
					})}

					<Route path="/home" element={<Navigate to={"/map/"} replace />} />
					<Route path={"/"} element={<Navigate to={"/map/"} replace />} />
				</Routes>
			</WorkOrderModalsProvider>
		</LocalizationProvider>
	);
};

export { CustomRoutes };
